<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
<div class="driver-load-report"><form [formGroup]="driverLoadForm">
  <ion-row>
    <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
     <div class="form-group form-group-lg no-margin">
            <label class="big-label">{{ CONSTS.DATE }} </label>
          </div>
          <app-form-date-picker
            [minDate]="minDate"
            [maxDate]="maxDate"
            [icon]="IMAGES.CALENDAR"
            [customClass]="'report-date-picker'"
            formControlName="date"
          ></app-form-date-picker>
    </ion-col>
    <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
   
          <app-form-select
            [label]="CONSTS.ROUTE"
            [options]="routes"
            [customClass]="'scan-type-dropdown report-select'"
            formControlName="route"
          >
          </app-form-select>
    </ion-col>
  </ion-row>
  
  </form><app-download-note [numRows]="'10,000'"> </app-download-note></div>
</app-modal-frame>

